import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Try to load Ionic PWA Elements (optional).
    // This enables native-like UI for certain web APIs when running as PWA.
    import('@ionic/pwa-elements/loader')
      .then(m => m.defineCustomElements(window))
      .catch(() => { /* package not installed or load failed; ignore */ });
  })
  .catch(err => console.log(err));
